RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Widgets = Marionette.Dashboard.views.Widgets.mixin({
        panelView: views.Panel,
        pdfView: views.PdfPanel,
        pngView: views.PngPanel,
        pptView: views.PptPanel,

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        getChildView: function (child) {
            const me = this;
            let View;
            const format = me.getProp('format');

            switch (format) {
                case RivalIQ.enums.exportFormat.PDF:
                    View = me.getPdfView(child);
                    break;
                case RivalIQ.enums.exportFormat.PPT:
                    View = me.getPptView(child);
                    break;
                case RivalIQ.enums.exportFormat.PNG:
                    View = me.getPngView(child);
                    break;
                default:
                    View = me.wrapperView || me.getPanelView(child);
                    break;
            }

            return View;
        },

        getPdfView: function (child) {
            const me = this;
            return me.pdfView || me.wrapperView || child.getView();
        },

        getPptView: function (child) {
            const me = this;
            return me.pptView || me.wrapperView || child.getView();
        },

        getPngView: function (child) {
            const me = this;
            return me.pngView || me.wrapperView || me.getPanelView(child);
        },

        getPanelView: function (child) {
            const me = this;
            return child.panelView || me.panelView || child.getView();
        }
    });

    views.WidgetsFocus = App.views.Widgets.extend({
        getPanelView: function () {
            return App.views.DetailsLayout.extend({
                showLeftToolbarActions: _.noop
            });
        }
    });
});
